import { render, staticRenderFns } from "./RefsContract.vue?vue&type=template&id=24eb1170&scoped=true&"
import script from "./RefsContract.vue?vue&type=script&lang=ts&"
export * from "./RefsContract.vue?vue&type=script&lang=ts&"
import style0 from "./RefsContract.vue?vue&type=style&index=0&id=24eb1170&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb1170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
